import rules from '@carwow/injection-default-rules-set';
import excludeBelowHeaderAdUrls from 'Protons/withTemplate/excludedBelowHeaderAdUrls';
import adDensityExperimentShouldInject from 'Config/localInjectionRules/injectMobileAds';

/**
 * Returns an ad configuration tailored for the ad-density experiment. When the
 * url is in the list urls that the experiment is running on, it tweaks the
 * mobile ad spacing and swaps in an alternate injection condition. Otherwise, it
 * falls back to the untouched defaults.
 */
export const getAdInjectionConfig = ({ adSettings, url = '' }) => {
  const isInAdDensityExperiment = excludeBelowHeaderAdUrls.has(url);

  const modifiedAdSettings = isInAdDensityExperiment
    ? {
      ...adSettings,
      numberOfWordsForFirstInjectionMobile: 150,
    }
    : adSettings;

  const rulesForInjection = isInAdDensityExperiment
    ? rules.map(rule => (
      rule.id === 'mobile-inline-ads'
        ? { ...rule, condition: adDensityExperimentShouldInject }
        : rule
    ))
    : rules;

  return { modifiedAdSettings, rulesForInjection };
};
